














































import { Vue, Component } from "av-ts";

@Component()
export default class ActionButtons extends Vue {

    back() {
        // this.$router.go(-1);
        this.$emit("back");
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/ActionButtons.vue